import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Row} from "react-bootstrap";
import { PencilIcon } from '@primer/octicons-react'
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';


const LocationAdminDetailsView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);

  // Initialize with actual JSON obj.  If not, will get error.
  const [locationAttrs, setLocationAttrs] = useState({
    id: '',
    code: '',
    description: '',
    site: '',
    building: '',
    wing: '',
    floor: '',
    room: '',
    roomType: '',
    roomSeq: '',
    externalSystemId: ''
  });

  const [currentLocationAttrs, setCurrentLocationAttrs] = useState({});

  const typeList = [
    { key: "CITY",     value: "CITY"     },
    { key: "DISTRICT", value: "DISTRICT" },
    { key: "SITE",     value: "SITE"     },
    { key: "BUILDING", value: "BUILDING" },
    { key: "WING",     value: "WING"     },
    { key: "FLOOR",    value: "FLOOR"    },
    { key: "ROOM",     value: "ROOM"     },
    { key: "LIFT",     value: "LIFT"     },
    { key: "OTHER",    value: "OTHER"    }
  ];

  // UI Functions

  // Initialize state
  useEffect(() => {
    if (props) {
      setLocationAttrs(props.objDetails);
      setCurrentLocationAttrs(props.objDetails);
    }
  }, [props]);

  // View vs Edit Modes
  const [editMode, setEditMode] = useState(false);

  const [errMsg, setErrMsg] = useState('');


  const handleEditAttrs = (e) => {
    e.preventDefault();
    setEditMode(true);
  }


  const onAttrsInputChange = (e) => {
    setLocationAttrs({ ...locationAttrs, [e.target.name]: e.target.value })
  }

  const onTypeSelect = (key, event) => {
    setLocationAttrs({ ...locationAttrs, type: key })
  }

  const handleEditCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setLocationAttrs(currentLocationAttrs);

    setEditMode(false);
  }

  const handleEditSubmit = (e) => {
    e.preventDefault();

    // Validate parameters
    if (!locationAttrs.description || locationAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
    } else if (locationAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + "200");

    } else if (!locationAttrs.type || locationAttrs.description.type === 0) {
      setErrMsg(t("I18N_ERR_Need_type"));

    } else if (locationAttrs.site && (locationAttrs.site.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_site") + "30");

    } else if (locationAttrs.building && (locationAttrs.building.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_building") + "30");

    } else if (locationAttrs.wing && (locationAttrs.wing.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_wing") + "30");

    } else if (locationAttrs.floor && (locationAttrs.floor.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_floor") + "30");

    } else if (locationAttrs.room && (locationAttrs.room.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_room") + "30");

    } else if (locationAttrs.roomType && (locationAttrs.roomType.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_room_type") + "30");

    } else if (locationAttrs.roomSeq && (locationAttrs.roomSeq.length > 10)) {
      setErrMsg(t("I18N_ERR_Max_len_room_seq") + "10");

    } else if (locationAttrs.externalSystemId && (locationAttrs.externalSystemId.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_ext_sys_id") + "30");

    } else {
      updateLocation();
    }
  }

  const updateLocation = () => {

    const reqBody = locationAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.put("locations/" + locationAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          refreshLocationAttrs(locationAttrs.id);

          // Restore UI to viewing mode
          setEditMode(false);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });

  }

  const refreshLocationAttrs = (locationId) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("locations/" + locationId);

        resolve(res.data);

        if (res.status === 200) {
          setLocationAttrs(res.data[0]);
          setCurrentLocationAttrs(res.data[0]);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST')
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_Location_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Location_info")}
            </span>
            {editMode ?
              null
              :
              <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          {editMode ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Location_code")}:</Col>
                  <Col>{t("I18N_Description")}: *</Col>
                  <Col>{t("I18N_Type")}:</Col>
                  <Col>{t("I18N_Ext_sys_id")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>{locationAttrs.code}</Col>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={locationAttrs.description}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!locationAttrs.type ? t("common:I18N_DROPDOWN_PROMPT") : t("common:I18N_" + locationAttrs.type) }
                      onSelect={onTypeSelect}>
                      {typeList.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("common:I18N_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} name="externalSystemId" value={locationAttrs.externalSystemId}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Site")}:</Col>
                  <Col>{t("I18N_Building")}:</Col>
                  <Col>{t("I18N_Wing")}: </Col>
                  <Col>{t("I18N_Floor")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} name="site" value={locationAttrs.site}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} name="building" value={locationAttrs.building}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} name="wing" value={locationAttrs.wing}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} name="floor" value={locationAttrs.floor}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Room")}:</Col>
                  <Col>{t("I18N_Room_type")}:</Col>
                  <Col>{t("I18N_Room_seq")}:</Col>
                  <Col></Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} name="room" value={locationAttrs.room}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} name="roomType" value={locationAttrs.roomType}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} name="roomSeq" value={locationAttrs.roomSeq}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col></Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>

                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsg}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
            :
            <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_Location_code")}:</Col>
                <Col>{t("I18N_Description")}:</Col>
                <Col>{t("I18N_Type")}:</Col>
                <Col>{t("I18N_Ext_sys_id")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{locationAttrs.code}</Col>
                <Col>{locationAttrs.description}</Col>
                <Col>{t("common:I18N_" + locationAttrs.type)}</Col>
                <Col>{locationAttrs.externalSystemId}</Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Site")}:</Col>
                <Col>{t("I18N_Building")}:</Col>
                <Col>{t("I18N_Wing")}:</Col>
                <Col>{t("I18N_Floor")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{locationAttrs.site}</Col>
                <Col>{locationAttrs.building}</Col>
                <Col>{locationAttrs.wing}</Col>
                <Col>{locationAttrs.floor}</Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Room")}:</Col>
                <Col>{t("I18N_Room_type")}:</Col>
                <Col>{t("I18N_Room_seq")}:</Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{locationAttrs.room}</Col>
                <Col>{locationAttrs.roomType}</Col>
                <Col>{locationAttrs.roomSeq}</Col>
                <Col></Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Created_by")}:</Col>
                <Col>{t("I18N_Time_created")}:</Col>
                <Col>{t("I18N_Updated_by")}:</Col>
                <Col>{t("I18N_Time_updated")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col style={{overflowWrap:'anywhere'}}>{locationAttrs.creatorUsername}</Col>
                <Col>{formatDate(locationAttrs.timeCreated)}</Col>
                <Col style={{overflowWrap:'anywhere'}}>{locationAttrs.updaterUsername}</Col>
                <Col>{formatDate(locationAttrs.timeUpdated)}</Col>
              </Row>

            </Container>
          }
        </div>


  

        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} >
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ fontSize:'12px', fontWeight:'300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
{/*
              <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                {updateLocationErrMsg}
              </span>
*/}
            </div>
          </Form.Group>
        </div>

      </Card>
    </>
  );
}
 
export default LocationAdminDetailsView;
